import { render, staticRenderFns } from "./IconGoogle.vue?vue&type=template&id=180e6702&"
import script from "./IconGoogle.vue?vue&type=script&lang=js&"
export * from "./IconGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180e6702')) {
      api.createRecord('180e6702', component.options)
    } else {
      api.reload('180e6702', component.options)
    }
    module.hot.accept("./IconGoogle.vue?vue&type=template&id=180e6702&", function () {
      api.rerender('180e6702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconGoogle.vue"
export default component.exports